import React, { Component } from "react";

class SectionEarnings extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <>
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-2d4b6f59 elementor-section-height-min-height elementor-hidden-mobile elementor-section-boxed elementor-section-height-default elementor-section-items-middle"
          data-id="2d4b6f59"
          data-element_type="section"
          data-settings='{"background_background":"classic"}'
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-4c2e8f8e"
              data-id="4c2e8f8e"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-bf3da6d elementor-widget elementor-widget-text-editor"
                  data-id="bf3da6d"
                  data-element_type="widget"
                  data-widget_type="text-editor.default"
                >
                  <div className="elementor-widget-container">
                    <p>
                      <span style={{ verticalAlign: "inherit" }}>
                        <span style={{ verticalAlign: "inherit" }}>
                          <span style={{ verticalAlign: "inherit" }}>
                            <span style={{ verticalAlign: "inherit" }}>
                              <span style={{ verticalAlign: "inherit" }}>
                                <span style={{ verticalAlign: "inherit" }}>
                                  <span style={{ verticalAlign: "inherit" }}>
                                    <span style={{ verticalAlign: "inherit" }}>
                                      GANHE{" "}
                                    </span>
                                  </span>
                                  <span style={{ verticalAlign: "inherit" }}>
                                    <span style={{ verticalAlign: "inherit" }}>
                                      EM{" "}
                                      <span style={{ color: "#ef3087" }}>
                                        5
                                      </span>{" "}
                                      NÍVEIS NO{" "}
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                      <span style={{ color: "#0097e1" }}>
                        <span style={{ verticalAlign: "inherit" }}>
                          <span style={{ verticalAlign: "inherit" }}>
                            <span style={{ verticalAlign: "inherit" }}>
                              <span style={{ verticalAlign: "inherit" }}>
                                <span style={{ verticalAlign: "inherit" }}>
                                  <span style={{ verticalAlign: "inherit" }}>
                                    <span style={{ verticalAlign: "inherit" }}>
                                      <span
                                        style={{ verticalAlign: "inherit" }}
                                      >
                                        SIG!
                                      </span>
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </p>{" "}
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-78b94d54 elementor-widget elementor-widget-text-editor"
                  data-id="78b94d54"
                  data-element_type="widget"
                  data-widget_type="text-editor.default"
                >
                  <div className="elementor-widget-container">
                    <p>
                      <span style={{ color: "#ef3087" }}>
                        <span style={{ verticalAlign: "inherit" }}>
                          <span style={{ verticalAlign: "inherit" }}>
                            Você ganha
                          </span>
                        </span>
                      </span>
                      <span style={{ verticalAlign: "inherit" }}>
                        <span style={{ verticalAlign: "inherit" }}>
                          {" "}
                          cada vez que um indicado seu realizar uma corrida
                          através da{" "}
                        </span>
                      </span>
                      <span style={{ color: "#0097e1" }}>
                        <span style={{ verticalAlign: "inherit" }}>
                          <span style={{ verticalAlign: "inherit" }}>
                            Sig Mobi
                          </span>
                        </span>
                      </span>
                      <span style={{ verticalAlign: "inherit" }}>
                        <span style={{ verticalAlign: "inherit" }}>
                          {" "}
                          em todo o Brasil!
                        </span>
                      </span>
                    </p>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-40635480 elementor-align-left bt-refer cadastro elementor-widget elementor-widget-button"
                  data-id="40635480"
                  data-element_type="widget"
                  data-widget_type="button.default"
                >
                  <div className="elementor-widget-container">
                    <div className="elementor-button-wrapper">
                      <a
                        className="elementor-button elementor-button-link elementor-size-lg"
                        href={this.props.url} style={{backgroundColor: '#57c600'}}
                      >
                        <span className="elementor-button-content-wrapper">
                          <span className="elementor-button-text">
                            QUERO ME CADASTRAR AGORA
                          </span>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-5bd8012d"
              data-id="5bd8012d"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-3fcfc5b elementor-hidden-mobile elementor-widget__width-inherit elementor-widget elementor-widget-image"
                  data-id="3fcfc5b"
                  data-element_type="widget"
                  data-widget_type="image.default"
                >
                  <div className="elementor-widget-container">
                    <img
                      decoding="async"
                      width="2560"
                      height="2560"
                      src="https://cdn.sigmobi.com/lpimg/Imagem-do-WhatsApp-de-2024-08-26-as-12.58.11_f1c56576-scaled-1.jpg"
                      className="attachment-full size-full wp-image-87"
                      alt=""
                      srcSet="https://cdn.sigmobi.com/lpimg/Imagem-do-WhatsApp-de-2024-08-26-as-12.58.11_f1c56576-scaled-1.jpg 2560w, https://cdn.sigmobi.com/lpimg/Imagem-do-WhatsApp-de-2024-08-26-as-12.58.11_f1c56576-scaled-1-300x300.jpg 300w, https://cdn.sigmobi.com/lpimg/Imagem-do-WhatsApp-de-2024-08-26-as-12.58.11_f1c56576-scaled-1-1024x1024.jpg 1024w, https://cdn.sigmobi.com/lpimg/Imagem-do-WhatsApp-de-2024-08-26-as-12.58.11_f1c56576-scaled-1-150x150.jpg 150w, https://cdn.sigmobi.com/lpimg/Imagem-do-WhatsApp-de-2024-08-26-as-12.58.11_f1c56576-scaled-1-768x768.jpg 768w, https://cdn.sigmobi.com/lpimg/Imagem-do-WhatsApp-de-2024-08-26-as-12.58.11_f1c56576-scaled-1-1536x1536.jpg 1536w, https://cdn.sigmobi.com/lpimg/Imagem-do-WhatsApp-de-2024-08-26-as-12.58.11_f1c56576-scaled-1-2048x2048.jpg 2048w"
                      sizes="(max-width: 2560px) 100vw, 2560px"
                    />{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-3c2b0c19 elementor-section-height-min-height elementor-hidden-desktop elementor-hidden-tablet elementor-section-boxed elementor-section-height-default elementor-section-items-middle"
          data-id="3c2b0c19"
          data-element_type="section"
          data-settings='{"background_background":"classic"}'
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-64019823"
              data-id="64019823"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-147fecfb elementor-widget elementor-widget-text-editor"
                  data-id="147fecfb"
                  data-element_type="widget"
                  data-widget_type="text-editor.default"
                >
                  <div className="elementor-widget-container">
                    <p>
                      <span style={{verticalAlign: 'inherit'}}>
                        <span style={{verticalAlign: 'inherit'}}>
                          <span style={{verticalAlign: 'inherit'}}>
                            <span style={{verticalAlign: 'inherit'}}>
                              <span style={{verticalAlign: 'inherit'}}>
                                <span style={{verticalAlign: 'inherit'}}>
                                  <span style={{verticalAlign: 'inherit'}}>
                                    <span style={{verticalAlign: 'inherit'}}>
                                      <span style={{verticalAlign: 'inherit'}}>
                                        <span style={{verticalAlign: 'inherit'}}>
                                          <span style={{verticalAlign: 'inherit'}}>
                                            <span style={{verticalAlign: 'inherit'}}>
                                              GANHE{" "}
                                            </span>
                                          </span>
                                        </span>
                                      </span>
                                    </span>
                                  </span>
                                  <span style={{verticalAlign: 'inherit'}}>
                                    <span style={{verticalAlign: 'inherit'}}>
                                      <span style={{verticalAlign: 'inherit'}}>
                                        <span style={{verticalAlign: 'inherit'}}>
                                          <span style={{verticalAlign: 'inherit'}}>
                                            <span style={{verticalAlign: 'inherit'}}>
                                              EM
                                              <span style={{color: '#ef3087'}}>
                                                {" "}
                                                5
                                              </span>{" "}
                                              NÍVEIS NO{" "}
                                            </span>
                                          </span>
                                        </span>
                                      </span>
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                      <span style={{color: '#0097e1'}}>
                        <span style={{verticalAlign: 'inherit'}}>
                          <span style={{verticalAlign: 'inherit'}}>
                            <span style={{verticalAlign: 'inherit'}}>
                              <span style={{verticalAlign: 'inherit'}}>
                                <span style={{verticalAlign: 'inherit'}}>
                                  <span style={{verticalAlign: 'inherit'}}>
                                    <span style={{verticalAlign: 'inherit'}}>
                                      <span style={{verticalAlign: 'inherit'}}>
                                        <span style={{verticalAlign: 'inherit'}}>
                                          <span style={{verticalAlign: 'inherit'}}>
                                            <span style={{verticalAlign: 'inherit'}}>
                                              <span style={{verticalAlign: 'inherit'}}>
                                                SIG!
                                              </span>
                                            </span>
                                          </span>
                                        </span>
                                      </span>
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </p>{" "}
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-53859e17 elementor-widget elementor-widget-text-editor"
                  data-id="53859e17"
                  data-element_type="widget"
                  data-widget_type="text-editor.default"
                >
                  <div className="elementor-widget-container">
                    <p>
                      <span style={{color: '#ef3087'}}>Você ganha</span> cada vez
                      que um indicado seu realizar uma corrida através da{" "}
                      <span style={{color: '#0097e1'}}>Sig Mobi</span> em todo o
                      Brasil!
                    </p>{" "}
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-49ea95a9"
              data-id="49ea95a9"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-40a73589 elementor-widget__width-inherit elementor-widget elementor-widget-image"
                  data-id="40a73589"
                  data-element_type="widget"
                  data-widget_type="image.default"
                >
                  <div className="elementor-widget-container">
                    <img
                      fetchPriority="high"
                      decoding="async"
                      width="2560"
                      height="2560"
                      src="https://cdn.sigmobi.com/lpimg/Imagem-do-WhatsApp-de-2024-08-26-as-12.58.11_f1c56576-scaled-1.jpg"
                      className="attachment-full size-full wp-image-87"
                      alt=""
                      srcSet="https://cdn.sigmobi.com/lpimg/Imagem-do-WhatsApp-de-2024-08-26-as-12.58.11_f1c56576-scaled-1.jpg 2560w, https://cdn.sigmobi.com/lpimg/Imagem-do-WhatsApp-de-2024-08-26-as-12.58.11_f1c56576-scaled-1-300x300.jpg 300w, https://cdn.sigmobi.com/lpimg/Imagem-do-WhatsApp-de-2024-08-26-as-12.58.11_f1c56576-scaled-1-1024x1024.jpg 1024w, https://cdn.sigmobi.com/lpimg/Imagem-do-WhatsApp-de-2024-08-26-as-12.58.11_f1c56576-scaled-1-150x150.jpg 150w, https://cdn.sigmobi.com/lpimg/Imagem-do-WhatsApp-de-2024-08-26-as-12.58.11_f1c56576-scaled-1-768x768.jpg 768w, https://cdn.sigmobi.com/lpimg/Imagem-do-WhatsApp-de-2024-08-26-as-12.58.11_f1c56576-scaled-1-1536x1536.jpg 1536w, https://cdn.sigmobi.com/lpimg/Imagem-do-WhatsApp-de-2024-08-26-as-12.58.11_f1c56576-scaled-1-2048x2048.jpg 2048w"
                      sizes="(max-width: 2560px) 100vw, 2560px"
                    />{" "}
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-1c065f85 elementor-align-left bt-refer cadastro elementor-widget elementor-widget-button"
                  data-id="1c065f85"
                  data-element_type="widget"
                  data-widget_type="button.default"
                >
                  <div className="elementor-widget-container">
                    <div className="elementor-button-wrapper">
                      <a
                        className="elementor-button elementor-button-link elementor-size-lg"
                        href={this.props.url} style={{backgroundColor: '#57c600'}}
                      >
                        <span className="elementor-button-content-wrapper">
                          <span className="elementor-button-text">
                            QUERO ME CADASTRAR AGORA
                          </span>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default SectionEarnings;
